<template>
    <b-navbar class="nav-border-bottom" toggleable="lg" type="light" variant="light">
      <b-navbar-brand href="/">
        <img class="logo" src="../assets/logo-app.png">
        <!--{{ $t('app.titre') }}-->
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/" active-class="active">{{ $t('menu.home') }}</b-nav-item>
          <b-nav-item-dropdown :text="$t('menu.expenses.name')" right>
            <b-dropdown-item to="/MonthlyExpense">{{ $t('menu.expenses.monethly') }}</b-dropdown-item>
            <b-dropdown-item to="/YearlyExpenses">{{ $t('menu.expenses.yearly') }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown :text="$t('menu.stock.name')" right>
            <b-dropdown-item to="/ListOfMovement">{{ $t('menu.stock.myStock') }}</b-dropdown-item>
            <b-dropdown-item to="/incoming">{{ $t('menu.stock.entryStock') }}</b-dropdown-item>
            <!--b-dropdown-item to="/outgoing">{{ $t('menu.stock.exitStock') }}</b-dropdown-item-->
            <b-dropdown-item to="/MovementOut">{{ $t('menu.stock.exitStock') }}</b-dropdown-item>
            <b-dropdown-item to="/ListOfDetailMovement">{{ $t('menu.stock.followlivestock') }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown :text="$t('menu.reference.name')" right>
            <b-dropdown-item to="/animals">{{ $t('menu.reference.animals') }}</b-dropdown-item>
            <b-dropdown-item to="/destinations">{{ $t('menu.reference.destinations') }}</b-dropdown-item>
            <b-dropdown-item to="/expenses">{{ $t('menu.reference.expenses') }}</b-dropdown-item>
            <b-dropdown-item to="/sources">{{ $t('menu.reference.sources') }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown v-if="isAdminsitartor()" :text="$t('menu.admin.name')" right>
            <b-dropdown-item to="/logs">{{ $t('menu.admin.logs') }}</b-dropdown-item>
            <b-dropdown-item to="/register">{{ $t('menu.admin.register') }}</b-dropdown-item>
            <b-dropdown-item to="/user-management">{{ $t('menu.admin.user-management') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
    
        <b-navbar-nav :class="selectedFlag !== 'ly' ? 'ml-auto ml-5' : 'mr-auto'">
          <!--b-nav-item :class="selectedFlag !== 'ar' ? 'ml-auto' : 'mr-auto'">
            <b-nav-form class="d-flex">
              <b-form-input size="sm" class="mr-sm-2" placeholder="Search" />
              <b-button size="sm" variant="success">{{ $t('menu.search')}}</b-button>
            </b-nav-form>
          </b-nav-item-->
        
        
  
        <b-nav-item-dropdown :text="selectedLanguage" right>
          <b-dropdown-item href="#" @click="selectLanguage('es', 'Español', 'es')">
            <img src="https://flagcdn.com/w40/es.png" alt="Spanish" class="flag-icon"> {{ $t('menu.lang.es') }}
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="selectLanguage('ar', 'العربية', 'ly')">
            <img src="https://flagcdn.com/w40/ly.png" alt="Arabic" class="flag-icon">  {{ $t('menu.lang.ar') }}
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="selectLanguage('en', 'English', 'gb')">
            <img src="https://flagcdn.com/w40/gb.png" alt="English" class="flag-icon">  {{ $t('menu.lang.en') }}
          </b-dropdown-item>        
          <template #button-content>
            <img :src="`https://flagcdn.com/w40/${selectedFlag}.png`" alt="" class="flag-icon"> <!-- {{ selectedLanguage }}-->
          </template>
        </b-nav-item-dropdown>
  
        <b-nav-item-dropdown right>
          <!--template #button-content>
            <em> {{ $t('menu.user.name') }}</em>
          </template-->
          <template #button-content>
            <div class="user-info">
              <img src="@/assets/user-avatar.png" alt="User Avatar" class="user-avatar" />
              <span class="user-name">Hi, <strong>{{ userFullName }}</strong></span>
            </div>
          </template>
          <b-dropdown-item href="/profile">{{ $t('menu.user.profile') }}</b-dropdown-item>
          <b-dropdown-item href="/settings">{{ $t('menu.user.settings') }}</b-dropdown-item>
          <b-dropdown-item href="/register">{{ $t('menu.user.register') }}</b-dropdown-item>
          <b-dropdown-item href="/user-management">{{ $t('menu.user.user-management') }}</b-dropdown-item>
          <b-dropdown-item @click="logout">{{ $t('menu.user.logout') }}</b-dropdown-item>

        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  
   
  </template>
  
  <script>
  import { AuthApi } from '../api';
  import router from "@/router";

  export default {
    data() {
      return {
        selectedLanguage: 'Lang', // Default dropdown text
        selectedFlag: '', // Default flag to display
        currentLocale: "en", // Default language
        userFullName: this.getUserInfo().firstName+' '+ this.getUserInfo().lastName || 'User',
      };
    },
    methods: {
      logout() {
        AuthApi.logout(); // Call the logout function
        router.push("/login");
      },
      selectLanguage(languageCode, languageName, flagCode) {
        console.log('selectLanguage')
        this.selectedLanguage = languageName; // Update the selected language text
        this.selectedFlag = flagCode; // Update the displayed flag
        this.currentLocale = languageCode
        this.changeLanguage()
      },
      changeLanguage() {
        console.log('changeLanguage')
        console.log('this.$i18n.locale --> ' + this.$i18n.locale)
          this.$i18n.locale = this.currentLocale; // Update the language
          document.documentElement.lang = this.currentLocale; // Update the HTML lang attribute
          document.documentElement.dir =
            this.currentLocale === "ar" ? "rtl" : "ltr"; // Update text direction
        },
        isAdminsitartor(){
          const userCategory = this.getUserInfo().userCategory
          return userCategory === 'S' || userCategory === 'A'
        },
        getUserInfo() {
          //console.log('****** ' + JSON.parse(localStorage.getItem("user")).id)
          
          return JSON.parse(localStorage.getItem("user")) || {};
        }
    },
    created() {
      //update later to be dynamic
      this.selectLanguage('en', 'English', 'gb');
    }
  };
  </script>
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  nav {
    padding: 30px;
  }
  
  nav a {
    font-weight: bold;
    color: #2c3e50;
  }
  
  nav a.router-link-exact-active {
    color: #42b983;
  }
  
  .active {
    font-weight: bold;
  }
  
  .ml-auto {
    margin-left: auto !important;
  }
  
  .mr-auto {
    margin-right: auto !important;
  }
  
  .navbar-nav.ml-auto {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .flag-icon {
    width: 35px;
    height: auto;
    margin-right: 8px;
    vertical-align: middle;
  }
  
  .logo {
  max-height: 66px !important;
  width: auto !important;
  max-width: 212px !important;
}


b-navbar-brand {
  display: flex;
  align-items: center;
  max-width: 200px; /* Adjust as needed */
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.user-name {
  font-size: 16px;
  color: #333;
}

  
  .nav-border-bottom {
    border-bottom: 3px solid #86b7fe !important;
  }
  
  .user-info {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  transition: background 0.3s ease;
}

.user-info:hover {
  background: #f2f2f2;
}

  
  html[lang="ar"] {
      direction: rtl;
      text-align: right;
    }
  
  </style>
  